import React, { Component } from 'react';
import moment from 'moment';

import { defaultSorter, dateSorter } from './Helpers';
import UserModel from './UserModel'

import { Table, Tooltip, Row, Col, Statistic } from 'antd';

class UrbioticaCounterMessagesTable extends Component {

  state = {
    filteredInfo: null,
    children: []
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters
    });
  };

  render() {
    let { filteredInfo } = this.state;
    filteredInfo = filteredInfo || {};
    let poms = [];
    this.props.data.forEach(element => {
      if ((element.pom) && poms.indexOf(element.pom) === -1) {
        poms.push(element.pom);
      }
    });
    poms.sort();
    let pomFilter = [];
    poms.forEach(pom => {
      pomFilter.push({ text: pom, value: pom });
    });
    return (
      <Table
        size='small'
        rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
        loading={this.props.loading ? this.props.loading : false}
        columns={[
          {
            title: 'POM',
            dataIndex: 'pom',
            key: 'pom',
            width: 30,
            filters: pomFilter,
            filteredValue: filteredInfo.pom || null,
            onFilter: (value, record) => record.pom === value,
            ellipsis: true
          }, {
            title: 'Obsazeno',
            dataIndex: 'measures',
            key: 'measures',
            width: 50,
          }, {
            title: 'Časová značka',
            dataIndex: 'stamps',
            key: 'stamps',
            width: 200,
            defaultSortOrder: 'descend',
            sorter: (a, b) => dateSorter(a.stamps, b.stamps),
            render: (text, record) => {
              return moment(text).format('L LTS');
            }
          }
        ]}
        dataSource={this.props.data}
        onChange={this.handleChange}
        pagination={{
          showSizeChanger: true,
          defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
            ? parseInt(localStorage.getItem('table_pageSize'))
            : 10,
          onShowSizeChange: (current, size) => {
            localStorage.setItem('table_pageSize', size);
          }
        }}
        style={{ border: '0px' }} />
    );
  }
}

export default UrbioticaCounterMessagesTable;


// WEBPACK FOOTER //
// ./src/components/UrbioticaCounterMessagesTable.js